// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"47":"3be2fa1b6c038228","159":"510dac901923f289","446":"7f9a90c9f1804b04","811":"298a5f437cd962e2","977":"da3c13bb37dbf773","997":"3477c15e02ffb021"}[chunkId] + ".js";
};